// extracted by mini-css-extract-plugin
export default {"container":"XkkyWAK9a2DhASjRFWcF"};